import "./index.scss";

import React from "react";

import { useFetchUserMetadata } from "@/messenger/hooks/useFetchUserMetadata";
// import { useUpdateMetadata } from "@/messenger/providers/Auth0Provider";
import { useAuth, useUpdateMetadata } from "@/messenger/providers/AuthProvider";
import Settings, { TSettingsPages } from "@/messenger/routes/Settings";

interface TNoChatSelectedProps {
    style?: React.CSSProperties
}
const ChangeSetting = ({ style }: TNoChatSelectedProps) => {

    const auth0Client = useAuth();
    const [accessToken, userMetadata, setUserMetadata, metadataUrl] = useFetchUserMetadata();
    const onMetadataChange = (metadata: any) => {
        setUserMetadata(metadata);
    };
    const updateMetadata = useUpdateMetadata(metadataUrl, accessToken, onMetadataChange, auth0Client.user, userMetadata);

    return(
        <div className="settings__wrapper" style={style}>
            <Settings userMetadata={userMetadata} updateMetadata={updateMetadata} initialCurrentPage={TSettingsPages.userSettings} />
        </div>
    );
};

export default ChangeSetting;